import Divider from '@portalterreno/react-ui-core/Divider';
import Typography from '@portalterreno/react-ui-core/Typography';
import React from 'react';

import StyledWrapper from './StyledWrapper';

export type SubContentProps = React.PropsWithChildren<{
  title: string;
  secondaryTitle?: string;
}>;

const SubContent: React.FC<SubContentProps> = ({
  title,
  secondaryTitle,
  children
}) => {
  return (
    <React.Fragment>
      <Divider />
      <StyledWrapper>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <Typography
            variant='subtitle2'
            as='h2'
            weight='semibold'
          >
            {title}
          </Typography>
          {secondaryTitle && (
            <Typography
              variant='text'
              weight='regular'
              color='blackCoral'
              style={{ alignSelf: 'flex-end' }}
            >
              {secondaryTitle}
            </Typography>
          )}
        </div>
        {children}
      </StyledWrapper>
    </React.Fragment>
  );
};

export default SubContent;
